// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  position: relative;
  min-height: 100vh;
  background-color: #000;
  overflow: hidden;
  color: #ffff;
  text-align: center;
  direction: rtl;
}

#tsparticles {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.about-content {
  position: relative;
  z-index: 5;
  padding: 5rem 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.about-logo {
  width: 120px;
  margin-bottom: 1.5rem;
  filter: drop-shadow(0 0 15px #8be01c);
}

.about-title {
  font-size: 2.6rem;
  font-weight: 800;
  background: linear-gradient(90deg, #00ffcc, #8be01c), #00ffaa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 30px #00ff6644;
  margin-bottom: 1rem;
}

.about-intro {
  font-size: 1.1rem;
  line-height: 2;
  color: #ffff;
  margin-bottom: 3rem;
}

.about-section {
  background: rgba(0, 40, 0, 0.35);
  border: 1px solid #9be01c;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 0 20px rgba(0, 255, 100, 0.15);
  transition: 0.3s;
}

.about-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 35px rgba(0, 255, 120, 0.4);
}

.about-section h2 {
  color: #8ee62a;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.about-section p, .about-section ul {
  color: #ffff;
  line-height: 1.8;
  text-align: justify;
}

.about-section ul {
  list-style: none;
  padding: 0;
}

.about-section li {
  margin: 0.6rem 0;
}

.about-highlight {
  border: 1px solid #80dd34;
  padding: 2rem;
  border-radius: 25px;
  background: linear-gradient(135deg, #002b10 0%, #000 100%);
  box-shadow: 0 0 40px rgba(0, 255, 100, 0.3);
  margin-top: 3rem;
}

.about-highlight h2 {
  color: #80dd34;
  margin-bottom: 1rem;
}

.about-highlight p {
  color: #ffff;
  line-height: 1.9;
}

.about-quote {
  margin-top: 4rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #80dd34;
  background: rgba(0, 40, 0, 0.4);
  padding: 1.5rem 2rem;
  border-radius: 25px;
  box-shadow: 0 0 25px rgba(70, 224, 119, 0.25);
}

.about-quote span {
  color: #ffffff;
  text-shadow: 0 0 15px #80dd34;
}

.about-footer {
  margin-top: 5rem;
  opacity: 0.6;
  font-size: 0.9rem;
  color: #80dd34;
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutUs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,0DAA0D;EAC1D,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".about-page {\n  position: relative;\n  min-height: 100vh;\n  background-color: #000;\n  overflow: hidden;\n  color: #ffff;\n  text-align: center;\n  direction: rtl;\n}\n\n#tsparticles {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.about-content {\n  position: relative;\n  z-index: 5;\n  padding: 5rem 1.5rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.about-logo {\n  width: 120px;\n  margin-bottom: 1.5rem;\n  filter: drop-shadow(0 0 15px #8be01c);\n}\n\n.about-title {\n  font-size: 2.6rem;\n  font-weight: 800;\n  background: linear-gradient(90deg, #00ffcc, #8be01c), #00ffaa);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 0 0 30px #00ff6644;\n  margin-bottom: 1rem;\n}\n\n.about-intro {\n  font-size: 1.1rem;\n  line-height: 2;\n  color: #ffff;\n  margin-bottom: 3rem;\n}\n\n.about-section {\n  background: rgba(0, 40, 0, 0.35);\n  border: 1px solid #9be01c;\n  border-radius: 20px;\n  backdrop-filter: blur(10px);\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 0 20px rgba(0, 255, 100, 0.15);\n  transition: 0.3s;\n}\n\n.about-section:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 0 35px rgba(0, 255, 120, 0.4);\n}\n\n.about-section h2 {\n  color: #8ee62a;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.about-section p, .about-section ul {\n  color: #ffff;\n  line-height: 1.8;\n  text-align: justify;\n}\n\n.about-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.about-section li {\n  margin: 0.6rem 0;\n}\n\n.about-highlight {\n  border: 1px solid #80dd34;\n  padding: 2rem;\n  border-radius: 25px;\n  background: linear-gradient(135deg, #002b10 0%, #000 100%);\n  box-shadow: 0 0 40px rgba(0, 255, 100, 0.3);\n  margin-top: 3rem;\n}\n\n.about-highlight h2 {\n  color: #80dd34;\n  margin-bottom: 1rem;\n}\n\n.about-highlight p {\n  color: #ffff;\n  line-height: 1.9;\n}\n\n.about-quote {\n  margin-top: 4rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #80dd34;\n  background: rgba(0, 40, 0, 0.4);\n  padding: 1.5rem 2rem;\n  border-radius: 25px;\n  box-shadow: 0 0 25px rgba(70, 224, 119, 0.25);\n}\n\n.about-quote span {\n  color: #ffffff;\n  text-shadow: 0 0 15px #80dd34;\n}\n\n.about-footer {\n  margin-top: 5rem;\n  opacity: 0.6;\n  font-size: 0.9rem;\n  color: #80dd34;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
